<template>
<div class="row columns">
    <div class="row columns">
        <div class="large-9 columns">
            avant
            <vue-cropper ref='cropper'
                      :guides="true"
                      :view-mode="2"
                      drag-mode="crop"
                      :auto-crop-area="0.5"
                      :min-container-width="250"
                      :min-container-height="180"
                      :background="true"
                      :rotatable="true"
                      :src="this.imageToCrop"
                      alt="Source Image"
                      :cropmove="this.cropImage">
            </vue-cropper>
            <br>
            <div class="row columns large-3 large-offset-8">
                <button @click="rotate" class="full-width">Rotation</button>
            </div>
        </div>
        <div class="large-3 columns">
            <div class="row columns">
              après
            </div>
            <div class="row columns">
                <img
                  :src="cropImg"
                  style="width: 200px; height: 150px; border: 1px solid gray"
                  alt="Cropped Image"
                />
            </div>
            <br>
            <br>
            <div class="row columns">
                <button @click="importCropped" class="full-width">Valider</button>
            </div>
            <br>
            <div class="row columns">
                <button @click="ImportFull" class="full-width">Importer sans retouches</button>
            </div>
            <br>
            <div class="row columns">
                <button @click="$emit('closeCropper')" class="full-width light-grey-button">Abandonner</button>
            </div>

        </div>
    </div>
    <br>
</div>
</template>

<script>
import modal from '../modal.vue'
import { mapGetters } from 'vuex'
import Paginate from 'vuejs-paginate'
import VueCropper from 'vue-cropperjs'
import img from '../../../api/img.api'

export default {
  name: 'imageLibrary',
  components: {
    modal,
    Paginate,
    VueCropper

  },
  props: {
    'fileToCrop': null
  },
  methods: {
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.imageToCrop = e.target.result
        this.$refs.cropper.replace(event.target.result)
      }
      reader.readAsDataURL(file)
    },
    cropImage () {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
    },
    rotate () {
      // guess what this does :)
      this.$refs.cropper.rotate(90)
    },
    ImportFull () {
      img.api.binaryUpload(this.imageToCrop, this.fileToCrop.name)
      .then(response => {
        this.$emit('imageChosen', response.data['url'])
        this.$emit('closeCropper')
      },
      error => {
        console.log('impossible to upload full size image ')
        console.log(error)
      })
    },
    importCropped () {
      img.api.binaryUpload(this.cropImg, this.fileToCrop.name)
      .then(response => {
        this.$emit('imageChosen', response.data['url'])
        this.$emit('closeCropper')
      },
      error => {
        console.log('impossible to upload cropped image : ' + error.text)
      })
    }
  },
  mounted () {
    this.createImage(this.fileToCrop)
  },
  computed:
  {
    ...mapGetters([
      'getAllThumbnails',
      'getPageCount'
    ])
  },
  data () {
    return {
      imageToCrop: null,
      cropImg: ''
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pagination {
    display: inline-block;
}

.pagination a {
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
    border: 1px solid #ddd;
}
.pagination a.active {
    background-color: #4CAF50;
    color: white;
}


</style>



// WEBPACK FOOTER //
// image-cropper.vue?6e2990cf